import { useEffect, useState } from 'react';
import { loadRuntimeConfig } from '../lib/config';

export function EnvironmentBadge() {
  const [isQa, setIsQa] = useState(false);

  useEffect(() => {
    void loadRuntimeConfig().then((config) => setIsQa(config.environment === 'qa'));
  }, []);

  if (!isQa) return null;
  return <div className="environment-badge fixed right-3 top-3 z-[100] rounded-full border border-clay/50 bg-ivory/95 px-2.5 py-1 text-[10px] font-bold tracking-[0.16em] text-clay shadow-soft" aria-label="QA environment">QA ENVIRONMENT</div>;
}
